var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"center_footer"},[_c('div',{staticClass:"bottom_left"},[_vm._v("宜宾天亿新材料科技有限公司版权所有 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v(" 蜀ICP备2022018661号-1")])])])])])
}]

export { render, staticRenderFns }